import { BuildQuickDetailsByIdApi } from '../../Apis/user/ApiConfig';
import {
    BUILD_QUICK_ACTION_BY_ID_ERROR,
    BUILD_QUICK_ACTION_BY_ID_REQUEST,
    BUILD_QUICK_ACTION_BY_ID_SUCCESS,
} from '../../Types/user/Types';

export const BuildQuickActionByIdSuccess = (res) => {
    return {
        type: BUILD_QUICK_ACTION_BY_ID_SUCCESS,
        payload: res,
    };
};
export const BuildQuickActionByIdError = (error) => {
    return {
        type: BUILD_QUICK_ACTION_BY_ID_ERROR,
        error: error,
    };
};

export const BuildQuickActionByIdRequest = (res) => {
    return {
        type: BUILD_QUICK_ACTION_BY_ID_REQUEST,
        payload: res,
    };
};

export const BuildQuickActionByIdActionHandler = (id, edit = '') => {
    return (dispatch) => {
        dispatch(BuildQuickActionByIdRequest());
        try {
            BuildQuickDetailsByIdApi(id, edit)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(BuildQuickActionByIdSuccess(res?.data));
                        } else {
                            dispatch(BuildQuickActionByIdError(res));
                        }
                    } else {
                        dispatch(BuildQuickActionByIdError(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        BuildQuickActionByIdError('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(BuildQuickActionByIdError(err));
        }
    };
};
